import { Button, Modal, message } from 'antd';
import React, { useState } from 'react';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import liracrypt from './Liracrypt/liracrypt';
import { useSelector } from 'react-redux';
import { createRoute } from '../utils/CustomFunc';
import noImg from '../assets/static/noImg.jpeg'
import ZenModal from './ZenModal';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const HyperLink = ({
    label = '',
    zenPop = {},
    style = {}
}) => {
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();

    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });

    const toggleModal = ({ show = false, data = undefined, type = type, loading = false }) => {
        setModal({ show, data, type, loading });
    }


    const zenPopupAction = (zenPopup) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        // if (zenPopup?.props) {
        //     urlData[zenPopup?.props] = value;
        // }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    //    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');

                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = () => {
        if (zenPop) {
            setZenModal(zenPop);
            if (zenPop?.typ === 'newTab') {
                let zenParams = {...searchParams, ...zenPop.params };
                if (zenPop?.api) {
                    zenParams.api = zenPop?.api;
                }
                let route = createRoute({
                    props: zenPop?.props,
                    record: {},
                    multiProps: zenPop?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPop?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPop?.typ === 'confirmationPopUp') {
                let urlData = {...searchParams, ...zenPop?.onOk?.params };
                // if (zenPop?.onOk?.multiProps) {
                //     zenPop?.onOk?.multiProps.forEach((prop) => {
                //         urlData[prop] = record[prop];
                //     });
                // };
                // if (zenPop?.onOk?.props) {
                //     urlData[zenPop?.onOk?.props] = record[zenPop?.onOk?.props];
                // }

                Modal.confirm({
                    title: zenPop?.text,
                    okText: zenPop?.okButtonText,
                    cancelText: zenPop?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPop?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPop)

        }
    }

    return (
        <>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
            <div style={{ ...style }} onClick={onColumnClick}>
                <span>{label}</span>
            </div>
        </>

    )
};

export default HyperLink;